import script from "./SocialMediaBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialMediaBtn.vue?vue&type=script&setup=true&lang=js"

import "./SocialMediaBtn.vue?vue&type=style&index=0&id=d7a91b38&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7a91b38"]])

export default __exports__